import produce from "immer";
import { create } from "zustand";
import * as api from "../services/users";
import { arrayToByIdsAllIds } from "./utils";

export const useUserStore = create((set) => ({
  byIds: {},
  allIds: [],
  total: 0,
  getById: async ({ id }) => {
    const one = await api.getById({ id });
    set(
      produce((draft) => {
        draft.byIds[one.data.id] = one.data;
        if (!draft.allIds.includes(one.data.id)) {
          draft.allIds.push(one.data.id);
        }
      }),
    );
  },
  fetchSome: async ({ q = "", limit = 20, offset = 0, sort_by = "name", sort_dir = "asc" }) => {
    const some = await api.getSome({
      q,
      limit,
      offset,
      sort_by,
      sort_dir,
    });
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;
      }),
    );
  },

  createOne: async ({ name, username, email, active, number, role_ids }) => {
    const one = await api.createOne({
      name,
      username,
      email,
      active,
      number,
      role_ids,
    });
    if (one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
          draft.allIds.unshift(one.data.id);
        }),
      );
    }
    return one;
  },

  updateOne: async ({ id, name, username, email, active, number, role_ids }) => {
    const one = await api.updateOne({
      id,
      name,
      username,
      email,
      active,
      number,
      role_ids,
    });
    if (one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },

  resetPassword: async ({ id }) => api.resetPassword({ id }),
}));
